import styled from 'styled-components';
import { COLOURS, FONT_WEIGHT, getBodyFont, SPACES, Z_INDEX } from '@belong/themes';
import { BaseFontStyles, BaseStyles } from '../Button';

const PromptMessage = styled.span`
  font-weight: ${FONT_WEIGHT.SEMI_BOLD};
  ${getBodyFont('medium')};
  position: relative;
`;

export const Prompt = styled(PromptMessage)`
  display: block;
`;

export const Root = styled.button<{ withShadow?: boolean }>`
  ${BaseStyles};
  ${BaseFontStyles};

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: ${COLOURS.WHITE};
  background: transparent; /* circle background rendered via ::before to enable transform without reflow */
  border-radius: 50%;
  position: relative;
  z-index: ${Z_INDEX.BACK_TO_TOP_TRIGGER};
  bottom: ${SPACES.medium}rem;
  height: 4.8rem;
  width: 4.8rem;
  margin-bottom: -4rem;
  outline: none;

  border: 0px solid ${COLOURS.WHITE};
  margin-right: ${SPACES.medium}rem;

  & > span:last-child {
    margin-top: -${SPACES.xxsmall}rem;
  }

  transition:
    box-shadow 150ms ease-in,
    opacity 0.5s linear,
    background-color 0.2s ease,
    border-color 0.2s ease;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 50%;
    background: ${COLOURS.BELONG_BLUE_ALT};
    z-index: -1; /* ensure background sits behind icon/text */
    pointer-events: none; /* don't block interactions */
    transition:
      transform 150ms ease,
      background-color 0.2s ease,
      border-color 0.2s ease;
    transform: scale(1); /* default size */
  }

  &:hover {
    box-shadow: 0 0px 10px rgba(0, 0, 0, 0.2);
  }

  &:hover::before {
    transform: scale(1.0833); /* 52px / 48px ≈ 1.0833 */
  }

  &:focus,
  &:active {
    outline: none;
    border: none;
    box-shadow: 0 0px 10px rgba(0, 0, 0, 0.2);
    &::after {
      content: '';
      position: absolute;
      inset: 0.1rem; /* controls the spacing between ring and outer edge */
      border-radius: 50%;
      border: ${SPACES.xxxsmall}rem solid ${COLOURS.WHITE};
      pointer-events: none;
    }
  }

  &:focus::before,
  &:active::before {
    transform: scale(1.0833);
  }

  @media (forced-colors: active) {
    &:not(:hover):not(:focus):not(:active)::before {
      outline: ${SPACES.xxxsmall}rem solid Highlight;
      inset: 0;
      border: 0;
    }

    &:focus::before,
    &:active::before,
    &:hover::before {
      outline: ${SPACES.xxsmall}rem solid Highlight;
    }
  }

  &[hidden] {
    display: none;
  }
`;
